import Vue from 'vue'
import Router from 'vue-router'
import Loading from '@/pages/loading'
import AddressManage from '@/pages/addressManage'
import ChooseAddress from '@/pages/chooseAddress'
import GiftEditAndSave from '@/pages/gift/editAndSave'
import AddressList from '@/pages/addressList.vue'
import TakeOutEditAndSave from '@/pages/takeOut/editAndSave'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'loading',
      component: Loading,
      meta: {
        allowAnonymous: true
      },
    },
    {
      path: '/addressManage',
      name: 'addressManage',
      component: AddressManage
    },
    {
      path: '/chooseAddress',
      name: 'chooseAddress',
      component: ChooseAddress
    },
    {
      path: '/giftEditAndSave',
      name: 'giftEditAndSave',
      component: GiftEditAndSave
    },
    {
      path: '/AddressList',
      name: 'addressList',
      component: AddressList
    },
    {
      path: '/takeOutEditAndSave',
      name: 'takeOutEditAndSave',
      component: TakeOutEditAndSave
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js